// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section[data-v-18681402]{margin-bottom:3em}@media (min-width: 768px){section[data-v-18681402]{margin-bottom:5em}}#dynamic-page[data-v-18681402]{min-height:calc(100vh - 270px)}@media (min-width: 768px){#dynamic-page[data-v-18681402]{min-height:calc(100vh - 470px)}}\n", ""]);
// Exports
module.exports = exports;
